import { createRoutine } from 'redux-saga-routines';

const changeUsername = createRoutine('PROFILE_CHANGE_USERNAME');
const changePassword = createRoutine('PROFILE_CHANGE_PASSWORD');

export default {
  changeUsername,
  changePassword,
};
